// <auto-generated>
// Code generated by EDHC (R) Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is
// regenerated.
// Hash: -2039762845
// </auto-generated>
import {
  HttpClient,
  HttpParams,
  HttpHeaders,
  HttpEventType,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import { Observable, Subject, Subscription } from 'rxjs';
import { SmartListResult, SmartListCriteria } from 'carehub-shared/smartlist';
import { Utils } from 'carehub-shared/utils';

import { SettingsEntry } from './models/settingsentry';

@Injectable({
  providedIn: 'root',
})
export class SettingsApiService {
  constructor(protected http: HttpClient) {}

  getSettings(): Observable<SettingsEntry[]> {
    const url = environment.chiliSauceApiRoot + `/core/Settings`;
    return this.http.get<SettingsEntry[]>(url);
  }
}
